import Reveal from "@/components/feature/Reveal";

export default function MessageSection() {
  return (
    <section id="message" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <Reveal className="mb-12 text-center md:mb-16">
          <p className="font-label text-[36px] font-bold tracking-[0.15em] text-foreground-700 md:text-[40px]">
            MESSAGE
          </p>
          <h2 className="mt-3 font-heading text-3xl font-black leading-snug text-foreground-950 md:text-5xl">
            代表メッセージ
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <Reveal>
            <div className="relative mx-auto w-full max-w-md overflow-hidden rounded-lg">
              <img
                src="/images/namba/message-photo.webp"
                alt="代表取締役 難波 伸敏"
                title="代表取締役 難波 伸敏"
                className="h-[420px] w-full object-cover object-top md:h-[520px]"
              />
            </div>
          </Reveal>

          <Reveal delay={120}>
            <p className="font-label text-sm font-bold text-foreground-700">代表取締役</p>
            <h3 className="mt-2 font-heading text-xl font-black text-foreground-950 md:text-2xl">
              難波 伸敏
            </h3>
            <p className="mt-6 font-body text-sm leading-relaxed text-foreground-700 md:text-base">
              「人材の価値を、もっと見える化したい」という想いが、ナンバの原点です。
              適性やスキルといった目に見えにくいものをデータとして可視化し、
              一人ひとりが持つ可能性を引き出す。そして、組織の強みを活かした持続的な成長へとつなげていく。
              私たちはテクノロジーの力で、人と組織の未来をつくっていきます。
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}